import React, { useState } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'moment/locale/ko'
import dynamic from 'next/dynamic'

const localizer = momentLocalizer(moment) // or globalizeLocalizer

const LiveEventModal = dynamic(() => import('./LiveEventModal'), { ssr: false })

const ColoredDateCellWrapper = ({ children }) =>
  React.cloneElement(React.Children.only(children), {
    style: {
      backgroundColor: 'black',
    },
  })

export interface LiveEvent extends Partial<Event> {
  id: string
  title: string
  musicians: Array<{
    id: string
    name: string
    useSlug: boolean
    slug: string
  }>
  poster: string
}

interface Props {
  liveEvents: LiveEvent[]
  date: Date
  onNavigate: (date: Date) => void
}

export default function LiveCalendar({ liveEvents, date, onNavigate }: Props) {
  const [selectedLiveEvent, setSelectedLiveEvent] = useState<LiveEvent | null>(null)

  return (
    <>
      {selectedLiveEvent && <LiveEventModal liveEvent={selectedLiveEvent} onClose={() => setSelectedLiveEvent(null)} />}
      <Calendar
        events={liveEvents}
        step={30}
        defaultDate={date}
        components={{
          timeSlotWrapper: ColoredDateCellWrapper,
        }}
        localizer={localizer}
        onSelectEvent={(event: LiveEvent) => {
          setSelectedLiveEvent(event)
        }}
        onNavigate={onNavigate}
      />
    </>
  )
}
